import React, { FC, useEffect, useState } from 'react';
import { Button } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { SearchInput } from 'common/components';
import { ERoute } from 'common/const/route.enum';
import { stringToNumber } from 'common/helpers/common.helper';
import { DEFAULT_VALUE_0 } from 'common/config';
import { useAppSelector } from 'app/store/store.hooks';
import { ReactComponent as ArrowRightShortIcon } from 'app/assets/images/redesign/arrow-right-short.svg';
import { ReactComponent as ArrowDownShortIcon } from 'app/assets/images/redesign/arrow-down-short.svg';
import { ReactComponent as ContractIcon } from 'app/assets/images/redesign/contract.svg';
import { ESettingsMenuTab, ESettingsTab } from 'entities/Settings/Settings.enum';
import { selectContractList } from 'entities/Contract/Contract.slice';

interface IComponentProps {
  active: boolean;
  isAccountAdmin?: boolean;
}

export const SettingsSidebarContractList: FC<IComponentProps> = ({ active, isAccountAdmin }) => {
  // contract
  const contractList = useAppSelector(selectContractList);

  const [search, setSearch] = useState<string>('');
  const [showContractList, setShowContractList] = useState<boolean>(false);
  const { tab, id, itemMenu } = useParams();
  const navigate = useNavigate();

  const contractListForView = contractList.filter((contract) => contract.buyerName?.toLowerCase().includes(search.toLowerCase()));

  useEffect(() => {
    if (tab === ESettingsTab.Contract) {
      setShowContractList(true);
    }
  }, [tab]);

  return (
    <>
      <div className={`settings-sidebar__btn ${isAccountAdmin ? 'hover' : ''} ${isAccountAdmin && active ? 'active' : ''}`}>
        <div className="settings-sidebar__btn-container">
          {isAccountAdmin && (
            <Button
              className="button-icon settings-sidebar__btn-toggle"
              icon={
                showContractList ? (
                  <ArrowDownShortIcon className="icon-arrow-down-short-dark-grey" />
                ) : (
                  <ArrowRightShortIcon className="icon-arrow-right-short-dark-grey" />
                )
              }
              onClick={() => {
                setShowContractList((prev) => !prev);
                setSearch('');
              }}
            />
          )}

          <div className="settings-sidebar__btn-title-container">
            <span className="text-h4-item-name settings-sidebar__btn-text">Контракты</span>
          </div>
        </div>

        <span className="text-tag color-dark-grey settings-sidebar__btn-text">Управление контрактами на поставку</span>
      </div>

      {showContractList && (
        <>
          <div className="mb-5">
            <SearchInput
              auto
              placeholder="Найти контракт"
              minLength={DEFAULT_VALUE_0}
              onSearch={async (value) => setSearch(value || '')}
            />
          </div>

          <div className="mb-14">
            {contractListForView.map((contract) => {
              return (
                <div
                  key={contract.id}
                  className={`settings-sidebar__list-item ${id && stringToNumber(id) === contract.id ? 'active' : ''}`}
                  onClick={() =>
                    navigate(
                      `${ERoute.Settings}/${ESettingsTab.Contract}/${contract.id}/${
                        !itemMenu ? ESettingsMenuTab.General : itemMenu
                      }`,
                    )
                  }
                >
                  <div className="settings-sidebar__list-item-icon">
                    <ContractIcon className="icon-contract-dark-grey" />
                  </div>

                  <div className="settings-sidebar__list-item-label">{contract.buyerName}</div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </>
  );
};
